<template>
  <div>
    <page-title/>
    <div container v-if="this.applicationStatus !== 'New' && this.applicationStatus !== 'Open' && this.userMessage.length !==0 ">
      <ul>
        <li v-for="item in this.userMessage" v-if="item !=='' ">
          <p class="lips validation">{{ item}} </p>
        </li>
      </ul>
    </div>
    <div v-else>
    <group-title
      :value="this.groupTitleInfoValues"
      @valueChanged="setValueChanged($event)"
      @groupTitleInfoUpdated="processGroupTitleInfoValues($event)"
      @titleSectionHasError="checkAndSetTitleSectionError($event)"
    />
      <div>
        <collapsible-section :collapsed='false' class='_pt0 _pb0'>
          <template #headerText>
            <h1 class='color-leaf'>Overview</h1>
          </template>
          <template #collapsibleSection>
            <div container v-if="!isLastSigner">
              <div grid="row wrap">
                <async-button
                  id="skipToProposal"
                  column="12" class="btn --sm _mtxs _mbxs"
                  :executing="eyeManageInfoValues.dataLoading"
                  :disabled="proposalOpen"
                  @clicked="skipToProposal()"
                >
                  SKIP TO APPLICATION/PROPOSAL
                </async-button>
              </div>
            </div>
            <collapsible-section
              class="sub-section"
              :collapsed="subSection.isCollapsed"
              :collapsible="subSection.collapsible"
              :is-collapse-button-disabled="disableCollapseButton(subSection)"
              :is-sub-section="true"
              :key="ssIndex"
              @collapseOthers="[saveClient(),collapseOtherSubSections(ssIndex)]"
              v-for="(subSection, ssIndex) in collapsibleSubSections"
            >
              <template #headerText>
                <h4 :id="subSection.component + 'Title'" :class="!subSection.isCollapsed ? '' : 'color-moon'">
                  {{ subSection.title }}
                </h4>
              </template>
              <template #collapsibleSection>
                <component
                  :is="subSection.component"
                  :value="subSection.value"
                  @valueChanged="setValueChanged($event)"
                  @groupInfoUpdated="processGroupInfoValues($event)"
                  @billingInfoUpdated="processBillingInfoValues($event)"
                  @initialMemInfoUpdated="processInitialMemberShipValues($event)"
                  @ongoingMemInfoUpdated="processOngoingMemberShipValues($event)"
                  @eyemanageInfoUpdated="processEyeManageInfoValues($event)"
                  @continue="[saveClient(),proceedToNextSubSections(ssIndex)]"
                  @saveEyemanageInfo="[saveEyeManageValues(ssIndex)]"
                />
              </template>
            </collapsible-section>
            <br><br>
          </template>
        </collapsible-section>
      </div>
    </div>
  </div>
</template>

<script>

  import CollapsibleSection from '@sections/CollapsibleSection'
  import AsyncButton from '@molecules/AsyncButton'
  import PageTitle from './ClientOnboarding/PageTitle'
  import GroupTitle from './ClientOnboarding/GroupTitle'
  import InternalMembership from './ClientOnboarding/InternalMembership'
  import ExternalMembership from './ClientOnboarding/ExternalMembership'
  import GroupInfo from './ClientOnboarding/GroupInfo'
  import Billing from './ClientOnboarding/Billing'
  import Eyemanage from './ClientOnboarding/Eyemanage'
  import Personal from './ClientOnboarding/Personal'
  import ClientOnboardingApi from '@api/ClientOnboardingApi'
  import formattable from '@mixins/formattable'
  import newClientStateOptions from '@mixins/clientOnboardSelectOptions'
  import { formatPhone } from '@/utils'
  import { eventBus } from '@/main'
  export default {
    components: {
      CollapsibleSection,
      AsyncButton,
      PageTitle,
      GroupTitle,
      GroupInfo,
      Billing,
      InternalMembership,
      ExternalMembership,
      Eyemanage,
      Personal
    },
    mixins: [
      formattable,
      newClientStateOptions
    ],
    data() {
      return {
        applicationId: this.$route.query.application,
        recipientUUID: this.$route.query.uui,
        isLastSigner: false,
        valueChanged: false,
        lastSectionValueAdded: false,
        applicationStatus: '',
        userMessage: [''],
        subSection: [],
        groupTitleInfoValues: {
          type: Object
        },
        groupInfoValues: {
          type: Object
        },
        billingInfoValues: {
          type: Object
        },
        initialMembershipValues: {
          type: Object
        },
        ongoingMembershipValues: {
          type: Object
        },
        eyeManageInfoValues: {
          type: Object
        },
        personalInfoValues: {
          type: Object
        }
      }
    },
    methods: {
      checkAndSetTitleSectionError(event) {
        if (event || (this.isLastSigner && this.groupTitleInfoValues.companyName === '')) {
          eventBus.$emit('groupTitleSectionHasError', true)
          this.groupInfoValues.hasTitleSectionError = true
          this.billingInfoValues.hasTitleSectionError = true
          this.initialMembershipValues.hasTitleSectionError = true
          this.ongoingMembershipValues.hasTitleSectionError = true
          this.eyeManageInfoValues.hasTitleSectionError = true
        } else {
          eventBus.$emit('groupTitleSectionHasError', false)
          this.groupInfoValues.hasTitleSectionError = false
          this.billingInfoValues.hasTitleSectionError = false
          this.initialMembershipValues.hasTitleSectionError = false
          this.ongoingMembershipValues.hasTitleSectionError = false
          this.eyeManageInfoValues.hasTitleSectionError = false
        }
      },
      processGroupTitleInfoValues(internalValue) {
        Object.keys(internalValue).forEach(key => {
          this.$set(this.groupTitleInfoValues, key, internalValue[key])
        })
      },
      processGroupInfoValues(internalValue) {
        this.groupInfoValues.isLastSigner = this.isLastSigner
        Object.keys(internalValue).forEach(key => {
          this.$set(this.groupInfoValues, key, internalValue[key])
        })
      },
      processBillingInfoValues(internalValue) {
        this.billingInfoValues.isLastSigner = this.isLastSigner
        Object.keys(internalValue).forEach(key => {
          this.$set(this.billingInfoValues, key, internalValue[key])
        })
      },
      processInitialMemberShipValues(internalValue) {
        this.initialMembershipValues.isLastSigner = this.isLastSigner
        Object.keys(internalValue).forEach(key => {
          this.$set(this.initialMembershipValues, key, internalValue[key])
        })
      },
      processOngoingMemberShipValues(internalValue) {
        this.ongoingMembershipValues.isLastSigner = this.isLastSigner
        Object.keys(internalValue).forEach(key => {
          this.$set(this.ongoingMembershipValues, key, internalValue[key])
        })
      },
      processEyeManageInfoValues(internalValue) {
        this.eyeManageInfoValues.isLastSigner = this.isLastSigner
        Object.keys(internalValue).forEach(key => {
          this.$set(this.eyeManageInfoValues, key, internalValue[key])
        })
      },
      async skipToProposal() {
        this.proceedToNextSubSections(this.collapsibleSubSections.length - 1)
        await this.saveEyeManageValues(this.collapsibleSubSections.length - 2)
      },
      async saveEyeManageValues(sectionIndex) {
        this.lastSectionValueAdded = true
        if (!this.valueChanged) {
          this.valueChanged = true // Assuming it is not last signer and allowing to save and proceed
        }
        this.eyeManageInfoValues.dataLoading = true
        let saveResult = await this.saveClient()
        if (saveResult) {
          await this.checkToMovePersonalSection(saveResult, sectionIndex)
        }
      },
      async checkToMovePersonalSection(saveResult, sectionIndex) {
        if (this.lastSectionValueAdded && saveResult) {
          this.personalInfoValues.iframeUrl = ''
          await this.getDocusignClosing()
          if (this.personalInfoValues.iframeUrl !== '') {
            this.proceedToNextSubSections(sectionIndex)
          } else {
            this.lastSectionValueAdded = false
          }
        } else {
          this.lastSectionValueAdded = false
        }
      },
      getStateObjectByCode(stateCode) {
        let stateObj = null
        if (stateCode !== null) {
          this.newClientStateOptions.forEach(item => {
            if (item.value.toLowerCase().indexOf(stateCode.toLowerCase()) >= 0) {
              stateObj = item
            }
          })
        }
        return stateObj
      },
      getStateObjectsByCodes(stateCodeArr) {
        let stateArrObj = []
        stateCodeArr.forEach(stateCodeItem => {
          this.newClientStateOptions.forEach(item => {
            if (item.value.toLowerCase().indexOf(stateCodeItem.toLowerCase()) >= 0) {
              stateArrObj.push(item)
            }
          })
        })
        return stateArrObj
      },
      getStateCodesByObject(stateObjects) {
        let stateCodes = []
        stateObjects.forEach((state, index) => {
          stateCodes.push(state.value)
        })
        return stateCodes
      },
      truncate(text, length) {
        if (text !== null && text.length > length) {
          return text.substring(0, length)
        } else {
          return text
        }
      },
      async saveClient() {
        let saveResult = false
        if (this.valueChanged) {
          this.clearErrors()
          await new ClientOnboardingApi().createNewClient({
                                                            applicationId: this.applicationId,
                                                            recipientUUID: this.recipientUUID
                                                          },
                                                          {
                                                            finalValidationIndicator: this.isLastSigner && this.lastSectionValueAdded ? 'Y' : 'N',
                                                            contract: {
                                                              companyName: this.groupTitleInfoValues.companyName || '',
                                                              effectiveDate: this.toIso8601Date(this.groupTitleInfoValues.contactEffectiveDate) || '',
                                                              groupName: this.groupInfoValues.businessName || '',
                                                              businessType: this.groupInfoValues.typeOfBusiness || '',
                                                              businessTypeOther: this.groupInfoValues.groupOther || '',
                                                              businessFeinTaxId: this.groupInfoValues.businessTaxID || '',
                                                              businessAddress: {
                                                                addressLine1: this.groupInfoValues.businessAddressLine1 || '',
                                                                addressLine2: this.groupInfoValues.businessAddressLine2 || '',
                                                                city: this.groupInfoValues.businessCity || '',
                                                                stateCode: this.groupInfoValues.businessState !== null ? this.groupInfoValues.businessState.value : '',
                                                                postalCode: this.groupInfoValues.businessZipCode || ''
                                                              },
                                                              serviceArea: this.groupInfoValues.serviceArea || '',
                                                              additionalStates: this.getStateCodesByObject(this.groupInfoValues.selectedStateFields),
                                                              primaryContact: {
                                                                firstName: this.groupInfoValues.primaryContactFirstName || '',
                                                                lastName: this.groupInfoValues.primaryContactLastName || '',
                                                                email: this.groupInfoValues.primaryContactEmail || '',
                                                                phone: this.groupInfoValues.primaryContactPhone || ''
                                                              },
                                                              billingContact: {
                                                                firstName: this.billingInfoValues.billingContactFirstName || '',
                                                                lastName: this.billingInfoValues.billingContactLastName || '',
                                                                email: this.billingInfoValues.billingContactEmail || '',
                                                                phone: this.billingInfoValues.billingContactPhone || ''
                                                              },
                                                              billingInvoiceSortIndicator: this.billingInfoValues.billingInvoiceNeedToSort,
                                                              billingAddressMatchIndicator: this.billingInfoValues.billingAddSameAsBusinessAdd ? 'Y' : 'N',
                                                              billingAddress: {
                                                                addressLine1: this.billingInfoValues.billingAddressLine1 || '',
                                                                addressLine2: this.billingInfoValues.billingAddressLine2 || '',
                                                                city: this.billingInfoValues.billingCity || '',
                                                                stateCode: this.billingInfoValues.billingState || '',
                                                                postalCode: this.billingInfoValues.billingZipCode || ''
                                                              },
                                                              initialMembership: {
                                                                format: this.initialMembershipValues.initFileFormat || '',
                                                                source: this.initialMembershipValues.initFileSender || '',
                                                                includeCobraIndicator: this.initialMembershipValues.initIncludeCobra || '',
                                                                tpaCompanyName: this.initialMembershipValues.initTpaCompName || '',
                                                                contact: {
                                                                  firstName: this.initialMembershipValues.initContactFn || '',
                                                                  lastName: this.initialMembershipValues.initContactLn || '',
                                                                  email: this.initialMembershipValues.initContactEmail || '',
                                                                  phone: this.initialMembershipValues.initContactPhone || ''
                                                                },
                                                                cobraFormat: this.initialMembershipValues.initCobraFileFormat || '',
                                                                cobraSource: this.initialMembershipValues.initCobraFileSender || '',
                                                                cobraTpaCompanyName: this.initialMembershipValues.initCobraTpaCompName || '',
                                                                cobraContact: {
                                                                  firstName: this.initialMembershipValues.initCobraContactFn || '',
                                                                  lastName: this.initialMembershipValues.initCobraContactLn || '',
                                                                  email: this.initialMembershipValues.initCobraContactEmail || '',
                                                                  phone: this.initialMembershipValues.initCobraContactPhone || ''
                                                                }
                                                              },
                                                              initialMembershipDate: this.toIso8601Date(this.initialMembershipValues.initExpFileDate),
                                                              initialMembershipCobraDate: this.toIso8601Date(this.initialMembershipValues.initCobraExpFileDate),
                                                              ongoingMembershipMatchIndicator: this.ongoingMembershipValues.ongoingMatchesInitial ? 'Y' : 'N',
                                                              ongoingMembership: {
                                                                format: this.ongoingMembershipValues.ongFileFormat || '',
                                                                source: this.ongoingMembershipValues.ongFileSender || '',
                                                                includeCobraIndicator: this.ongoingMembershipValues.ongIncludeCobra || '',
                                                                tpaCompanyName: this.ongoingMembershipValues.ongTpaCompName || '',
                                                                contact: {
                                                                  firstName: this.ongoingMembershipValues.ongContactFn || '',
                                                                  lastName: this.ongoingMembershipValues.ongContactLn || '',
                                                                  email: this.ongoingMembershipValues.ongContactEmail || '',
                                                                  phone: this.ongoingMembershipValues.ongContactPhone || ''
                                                                },
                                                                cobraFormat: this.ongoingMembershipValues.ongCobraFileFormat || '',
                                                                cobraSource: this.ongoingMembershipValues.ongCobraFileSender || '',
                                                                cobraTpaCompanyName: this.ongoingMembershipValues.ongCobraTpaCompName || '',
                                                                cobraContact: {
                                                                  firstName: this.ongoingMembershipValues.ongCobraContactFn || '',
                                                                  lastName: this.ongoingMembershipValues.ongCobraContactLn || '',
                                                                  email: this.ongoingMembershipValues.ongCobraContactEmail || '',
                                                                  phone: this.ongoingMembershipValues.ongCobraContactPhone || ''
                                                                }
                                                              },
                                                              existingBrokerId: this.eyeManageInfoValues.existingBrokerUserId || '',
                                                              primaryEyemanageUser: this.eyeManageInfoValues.primaryEyemanageUser || '',
                                                              eyeManageContact: {
                                                                firstName: this.eyeManageInfoValues.eyemanageFirstName || '',
                                                                lastName: this.eyeManageInfoValues.eyemanageLastName || '',
                                                                email: this.eyeManageInfoValues.eyemanageEmail || ''
                                                              }
                                                            }
                                                          }).then(res => {
            this.setValueChanged(false)
            if (res.status === 'ValidationFailure') {
              if (this.eyeManageInfoValues.dataLoading) {
                this.eyeManageInfoValues.dataLoading = false
              }
              this.pushErrors(res, '')
            } else {
              saveResult = true
            }
          }).catch(err => {
            if (this.eyeManageInfoValues.dataLoading) {
              this.eyeManageInfoValues.dataLoading = false
            }
            this.pushErrors(err, 'err')
          })
        }
        return saveResult
      },
      async getClientInfo() {
        await new ClientOnboardingApi().getClientDetails({
          applicationId: this.applicationId,
          recipientUUID: this.recipientUUID
        }).then(res => {
          this.applicationStatus = res.status
          this.userMessage.push(res.userMessage)
          if (this.applicationStatus === 'New' || this.applicationStatus === 'Open') {
            this.isLastSigner = res.validationRequiredIndicator === 'Y'
            this.groupTitleInfoValues.isLastSigner = this.isLastSigner
            this.groupInfoValues.isLastSigner = this.isLastSigner
            this.billingInfoValues.isLastSigner = this.isLastSigner
            this.initialMembershipValues.isLastSigner = this.isLastSigner
            this.ongoingMembershipValues.isLastSigner = this.isLastSigner
            this.eyeManageInfoValues.isLastSigner = this.isLastSigner

            let contractResObj = res.contract
            this.groupTitleInfoValues.companyName = contractResObj.companyName || ''
            this.groupTitleInfoValues.contactEffectiveDate = this.formatDate(contractResObj.effectiveDate)
            this.groupTitleInfoValues.businessState = this.getStateObjectByCode(contractResObj.businessAddress.stateCode)
            this.groupTitleInfoValues.mailTo = contractResObj.businessCoordinator.email || ''

            this.groupInfoValues.businessName = this.truncate(contractResObj.groupName, 38) || ''
            this.groupInfoValues.typeOfBusiness = contractResObj.businessType || ''
            this.groupInfoValues.groupOther = contractResObj.businessTypeOther || ''
            this.groupInfoValues.businessTaxID = contractResObj.businessFeinTaxId || ''
            this.groupInfoValues.businessAddressLine1 = contractResObj.businessAddress.addressLine1 || ''
            this.groupInfoValues.businessAddressLine2 = contractResObj.businessAddress.addressLine2 || ''
            this.groupInfoValues.businessCity = contractResObj.businessAddress.city || ''
            this.groupInfoValues.businessState = this.getStateObjectByCode(contractResObj.businessAddress.stateCode)
            this.groupInfoValues.businessZipCode = contractResObj.businessAddress.postalCode || ''
            this.groupInfoValues.serviceArea = contractResObj.serviceArea || ''
            this.groupInfoValues.primaryContactFirstName = contractResObj.primaryContact.firstName || ''
            this.groupInfoValues.primaryContactLastName = contractResObj.primaryContact.lastName || ''
            this.groupInfoValues.primaryContactPhone = formatPhone(contractResObj.primaryContact.phone) || ''
            this.groupInfoValues.primaryContactEmail = contractResObj.primaryContact.email || ''
            this.groupInfoValues.selectedStateFields = this.getStateObjectsByCodes(contractResObj.additionalStates)

            this.billingInfoValues.billingContactFirstName = contractResObj.billingContact.firstName || ''
            this.billingInfoValues.billingContactLastName = contractResObj.billingContact.lastName || ''
            this.billingInfoValues.billingContactPhone = formatPhone(contractResObj.billingContact.phone) || ''
            this.billingInfoValues.billingContactEmail = contractResObj.billingContact.email || ''
            this.billingInfoValues.billingInvoiceNeedToSort = contractResObj.billingInvoiceSortIndicator
            this.billingInfoValues.billingAddSameAsBusinessAdd = contractResObj.billingAddressMatchIndicator === 'Y'
            this.billingInfoValues.billingAddressLine1 = contractResObj.billingAddress.addressLine1 || ''
            this.billingInfoValues.billingAddressLine2 = contractResObj.billingAddress.addressLine2 || ''
            this.billingInfoValues.billingCity = contractResObj.billingAddress.city || ''
            this.billingInfoValues.billingState = contractResObj.billingAddress.stateCode
            this.billingInfoValues.billingZipCode = contractResObj.billingAddress.postalCode || ''

            this.initialMembershipValues.initFileFormat = contractResObj.initialMembership.format || ''
            this.initialMembershipValues.initFileSender = contractResObj.initialMembership.source || ''
            this.initialMembershipValues.initIncludeCobra = contractResObj.initialMembership.includeCobraIndicator
            this.initialMembershipValues.initExpFileDate = contractResObj.initialMembershipDate
            this.initialMembershipValues.initTpaCompName = contractResObj.initialMembership.tpaCompanyName || ''
            this.initialMembershipValues.initContactFn = contractResObj.initialMembership.contact.firstName || ''
            this.initialMembershipValues.initContactLn = contractResObj.initialMembership.contact.lastName || ''
            this.initialMembershipValues.initContactEmail = contractResObj.initialMembership.contact.email || ''
            this.initialMembershipValues.initContactPhone = formatPhone(contractResObj.initialMembership.contact.phone) || ''
            this.initialMembershipValues.initCobraFileFormat = contractResObj.initialMembership.cobraFormat || ''
            this.initialMembershipValues.initCobraFileSender = contractResObj.initialMembership.cobraSource || ''
            this.initialMembershipValues.initCobraExpFileDate = contractResObj.initialMembershipCobraDate
            this.initialMembershipValues.initCobraTpaCompName = contractResObj.initialMembership.cobraTpaCompanyName || ''
            this.initialMembershipValues.initCobraContactFn = contractResObj.initialMembership.cobraContact.firstName || ''
            this.initialMembershipValues.initCobraContactLn = contractResObj.initialMembership.cobraContact.lastName || ''
            this.initialMembershipValues.initCobraContactEmail = contractResObj.initialMembership.cobraContact.email || ''
            this.initialMembershipValues.initCobraContactPhone = formatPhone(contractResObj.initialMembership.cobraContact.phone) || ''

            this.ongoingMembershipValues.ongoingMatchesInitial = contractResObj.ongoingMembershipMatchIndicator === 'Y'
            this.ongoingMembershipValues.ongFileFormat = contractResObj.ongoingMembership.format || ''
            this.ongoingMembershipValues.ongFileSender = contractResObj.ongoingMembership.source || ''
            this.ongoingMembershipValues.ongIncludeCobra = contractResObj.ongoingMembership.includeCobraIndicator
            this.ongoingMembershipValues.ongTpaCompName = contractResObj.ongoingMembership.tpaCompanyName || ''
            this.ongoingMembershipValues.ongContactFn = contractResObj.ongoingMembership.contact.firstName || ''
            this.ongoingMembershipValues.ongContactLn = contractResObj.ongoingMembership.contact.lastName || ''
            this.ongoingMembershipValues.ongContactEmail = contractResObj.ongoingMembership.contact.email || ''
            this.ongoingMembershipValues.ongContactPhone = formatPhone(contractResObj.ongoingMembership.contact.phone) || ''
            this.ongoingMembershipValues.ongCobraFileFormat = contractResObj.ongoingMembership.cobraFormat || ''
            this.ongoingMembershipValues.ongCobraFileSender = contractResObj.ongoingMembership.cobraSource || ''
            this.ongoingMembershipValues.ongCobraTpaCompName = contractResObj.ongoingMembership.cobraTpaCompanyName || ''
            this.ongoingMembershipValues.ongCobraContactFn = contractResObj.ongoingMembership.cobraContact.firstName || ''
            this.ongoingMembershipValues.ongCobraContactLn = contractResObj.ongoingMembership.cobraContact.lastName || ''
            this.ongoingMembershipValues.ongCobraContactEmail = contractResObj.ongoingMembership.cobraContact.email || ''
            this.ongoingMembershipValues.ongCobraContactPhone = formatPhone(contractResObj.ongoingMembership.cobraContact.phone) || ''

            this.eyeManageInfoValues.existingBrokerUserId = contractResObj.existingBrokerId || ''
            this.eyeManageInfoValues.primaryEyemanageUser = contractResObj.primaryEyemanageUser || ''
            this.eyeManageInfoValues.eyemanageFirstName = contractResObj.eyeManageContact.firstName || ''
            this.eyeManageInfoValues.eyemanageLastName = contractResObj.eyeManageContact.lastName || ''
            this.eyeManageInfoValues.eyemanageEmail = contractResObj.eyeManageContact.email || ''
          }
        }).catch(err => {
          this.pushErrors(err, 'err')
        })
      },
      async getDocusignClosing() {
        await new ClientOnboardingApi().getDocusignClosing({
          applicationId: this.applicationId,
          recipientUUID: this.recipientUUID
        }).then(res => {
          this.personalInfoValues.iframeUrl = res.signingUrl || ''
          this.eyeManageInfoValues.dataLoading = false
        }).catch(err => {
          this.eyeManageInfoValues.dataLoading = false
          this.pushErrors(err, 'err')
        })
      },
      pushErrors(err, type) {
        this.collapsibleSubSections.forEach((section, key) => {
          if (type === '') {
            if (err.validation.errorCount !== 0) {
              err.validation.errors.forEach((error, eIndex) => {
                if (error.level === 'error') {
                  section.value.userMessage.push(error.field + ' - ' + error.userMessage)
                }
              })
            }
          } else {
            section.value.userMessage.push(err.name)
          }
        })
      },
      clearErrors() {
        this.collapsibleSubSections.forEach((section, key) => {
          section.value.userMessage.splice(0, section.value.userMessage.length)
        })
      },
      proceedToNextSubSections(index) {
        this.collapsibleSubSections.forEach((section, key) => {
          for (let j = 0; j <= index; j++) {
            if (key === j) {
              section.isDisabled = false
              section.isCollapsed = true
            }
          }
          if (key === index + 1) {
            section.isDisabled = false
            section.isCollapsed = false
          }
        })
      },
      collapseOtherSubSections(index) {
        this.collapsibleSubSections.forEach((section, key) => {
          if (key === index) {
            section.isCollapsed = false
          } else {
            section.isCollapsed = true

            let nextIndex = index + 1
            this.collapsibleSubSections.forEach((section, nextKey) => {
              if (nextKey === nextIndex) {
                this.lastSectionValueAdded = false // if user moves to other section, disable proposal section.
                section.isDisabled = true // enable Disabling the sections
                nextIndex++
              }
            })
          }
        })
      },
      disableCollapseButton(subSection) {
        if (!this.lastSectionValueAdded && subSection.component === 'Personal') {
          return true
        } else {
          return this.isLastSigner ? subSection.isDisabled : false
        }
      },
      setValueChanged(val) {
        this.valueChanged = val
      },
      confirmLeaving(evt) {
        const confirmationMessage = 'You have unsaved changes. Are you sure you wish to leave?'
        if (this.valueChanged) {
          evt.returnValue = confirmationMessage
          return confirmationMessage
        }
      }
    },
    computed: {
      proposalOpen() {
        return !this.collapsibleSubSections[this.collapsibleSubSections.length - 1].isCollapsed
      },
      collapsibleSubSections: {
        get: function () {
          return this.subSection = [
            {
              title: 'GROUP INFORMATION',
              component: 'GroupInfo',
              isCollapsed: false,
              isDisabled: false,
              value: {
                userMessage: [],
                groupInfoValues: this.groupInfoValues
              }
            },
            {
              title: 'BILLING INFORMATION',
              component: 'Billing',
              isCollapsed: true,
              isDisabled: true,
              value: {
                userMessage: [],
                groupInfoValues: this.groupInfoValues,
                billingInfoValues: this.billingInfoValues
              }
            },
            {
              title: 'INITIAL MEMBERSHIP INFORMATION',
              component: 'InternalMembership',
              isCollapsed: true,
              isDisabled: true,
              value: {
                userMessage: [],
                initialMembershipValues: this.initialMembershipValues
              }
            },
            {
              title: 'ONGOING MEMBERSHIP INFORMATION',
              component: 'ExternalMembership',
              isCollapsed: true,
              isDisabled: true,
              value: {
                userMessage: [],
                initialMembershipValues: this.initialMembershipValues,
                ongoingMembershipValues: this.ongoingMembershipValues
              }
            },
            {
              title: 'EYEMANAGE',
              component: 'Eyemanage',
              isCollapsed: true,
              isDisabled: true,
              value: {
                userMessage: [],
                groupInfoValues: this.groupInfoValues,
                billingInfoValues: this.billingInfoValues,
                initialMembershipValues: this.initialMembershipValues,
                ongoingMembershipValues: this.ongoingMembershipValues,
                eyeManageInfoValues: this.eyeManageInfoValues
              }
            },
            {
              title: 'PROPOSAL',
              component: 'Personal',
              isCollapsed: true,
              isDisabled: true,
              value: {
                userMessage: [],
                personalInfoValues: this.personalInfoValues
              }
            }
          ]
        },
        set: function (newValue) {
          this.subSection = newValue
        }
      }
    },
    async created() {
      await this.getClientInfo()
      this.checkAndSetTitleSectionError()
      window.addEventListener('beforeunload', this.confirmLeaving)
    }
  }
</script>
